import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_follow_any_of_the_following_practices_related_to_w'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_follow_any_of_the_following_practices_related_to_w',
  name: 'Does the facility follow any of the following practices related to worker pregnancy before or at hiring?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FACILITY_REQUIRES_PREGNANCY_TEST_BEFORE_OR_AT_HIRING',
      text: 'Facility requires pregnancy test before or at hiring',
      externalIds: [
        {
          id: 'disc-3-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_REQUIRES_VIRGINITY_TEST_BEFORE_OR_AT_HIRING',
      text: 'Facility requires virginity test before or at hiring',
      externalIds: [
        {
          id: 'disc-3-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_REQUIRES_WORKER_TO_PROVIDE_COMMITMENTS_VERBALLY_OR_IN_',
      text: 'Facility requires worker to provide commitments (verbally or in writing) that they will not become pregnant',
      externalIds: [
        {
          id: 'disc-3-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_REQUIRES_THE_USE_OF_CONTRACEPTIVES_OR_OTHER_FORMS_OF_B',
      text: 'Facility requires the use of contraceptives or other forms of birth control at hiring',
      externalIds: [
        {
          id: 'disc-3-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'disc-3-5x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FACILITY_REQUIRES_PREGNANCY_TEST_BEFORE_OR_AT_HIRING',
                'FACILITY_REQUIRES_VIRGINITY_TEST_BEFORE_OR_AT_HIRING',
                'FACILITY_REQUIRES_WORKER_TO_PROVIDE_COMMITMENTS_VERBALLY_OR_IN_',
                'FACILITY_REQUIRES_THE_USE_OF_CONTRACEPTIVES_OR_OTHER_FORMS_OF_B',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-dis-35',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5770,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
